import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CloseIconComponent } from '@kuiper/icons';
import { ClickOutSideDirective } from '../../../../ui-components/directives/clickOutSide.directive';
import { TooltipDirective } from '../../../../ui-components/lib/tooltip/tooltip.directive';

@Component({
  selector: 'lib-off-canvas',
  imports: [CloseIconComponent, ClickOutSideDirective, TooltipDirective],
  templateUrl: './off-canvas.component.html',
  styleUrl: './off-canvas.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class OffCanvasComponent {
  title = input.required<string>();
  showTitle = input(true);
  hide = output<boolean>();
  width = input<string>('50.6875');
  offCanvasContentClass = input<string>('h-full');
  turnOffOutSideClick = input<boolean>(false);
  protected readonly nameTooltipClass =
    'bg-white p-md rounded-lg shadow-lg !w-auto tooltip-arrow tooltip-arrow-top';

  close() {
    this.hide.emit(false);
  }
}
